// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<polygon points="4.7,4 11.4,10.6 10.7,11.3 4,4.7 4,8.5 3,8.5 3,3 8.5,3 8.5,4" />
	<polygon points="20,19.3 13.4,12.6 12.7,13.3 19.3,20 15.5,20 15.5,21 21,21 21,15.5 20,15.5" />
	<polygon points="15.5,3 15.5,4 19.3,4 12.7,10.6 13.4,11.3 20,4.7 20,8.5 21,8.5 21,3" />
	<polygon points="10.6,12.6 4,19.3 4,15.5 3,15.5 3,21 8.5,21 8.5,20 4.7,20 11.4,13.3" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-maximize-DXZ6_N3P.js.map
